import { TextField, TextFieldVariants } from "@mui/material";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";

type IzunTextFieldProps = {
  registerRetrun: UseFormRegisterReturn;
  error?: FieldError;
  label: string;
  varient?: TextFieldVariants;
  type: React.HTMLInputTypeAttribute;
  required?: boolean;
  defaultValue?: unknown;
};

const IzunTextField = ({
  registerRetrun,
  error,
  label,
  required = false,
  varient = "outlined",
  type = "text",
  defaultValue,
}: IzunTextFieldProps) => {
  return (
    <TextField
      slotProps={{
        inputLabel: { shrink: true },
      }}
      {...registerRetrun}
      className={`border rounded outline-none px-4 py-2 ${
        error ? "border-red-400 shadow-red-300" : ""
      }`}
      fullWidth
      required={required}
      id={label}
      label={label}
      variant={varient}
      defaultValue={defaultValue}
      type={type}
      onInvalid={(e) => e.preventDefault()}
      error={!!error}
      sx={{
        "& .MuiFormLabel-asterisk": {
          color: "red",
        },
        direction: "rtl",
        textAlign: "right",
      }}
    />
  );
};

export default IzunTextField;
